import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

export interface NamedType {
	id: string;
	name: string;
}

export interface WorldTypesResponse {
	pointOfInterestTypes: NamedType[];
	itemTypes?: NamedType[];
	questStatuses?: NamedType[];
	questTiers?: NamedType[];
	visibilityStates: NamedType[];
	characterStatuses?: NamedType[];
	itemRarities?: NamedType[];
}

@Injectable({ providedIn: 'root' })
export class TypesService {
	constructor(private readonly http: HttpClient) {}

	get(worldId: string): Observable<WorldTypesResponse> {
		return this.http.get<WorldTypesResponse>(`${environment.api.baseUrl}/v1/worlds/${worldId}/types`);
	}
}
